import { apiClient } from '@/api/client'
import type { User } from '@/features/auth/types'
import type { UserCreatePayload, UserListResponse, UserUpdatePayload } from '@/features/users/types'

export const usersApi = {
  async list(params: { q?: string; offset?: number; limit?: number }): Promise<UserListResponse> {
    const { data } = await apiClient.get<UserListResponse>('/users', { params })
    return data
  },
  async create(payload: UserCreatePayload): Promise<User> {
    const { data } = await apiClient.post<User>('/users', payload)
    return data
  },
  async update(userId: string, payload: UserUpdatePayload): Promise<User> {
    const { data } = await apiClient.patch<User>(`/users/${userId}`, payload)
    return data
  },
  async activate(userId: string): Promise<User> {
    const { data } = await apiClient.post<User>(`/users/${userId}/activate`)
    return data
  },
  async deactivate(userId: string): Promise<User> {
    const { data } = await apiClient.post<User>(`/users/${userId}/deactivate`)
    return data
  },
  async remove(userId: string): Promise<void> {
    await apiClient.delete(`/users/${userId}`)
  },
}
